// Handles dismissible announcement bar using localStorage
(function(){
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    var bar = document.querySelector('.dc-announcement');
    if(!bar) return;
    var key = bar.getAttribute('data-announcement-key') || '';
    var storageKey = 'dc:announcement:dismissed:' + (key || 'default');

    if(localStorage.getItem(storageKey) === '1'){
      bar.style.display = 'none';
      return;
    }

    var closeBtn = bar.querySelector('.dc-announcement-close');
    if(closeBtn){
      closeBtn.addEventListener('click', function(){
        try { localStorage.setItem(storageKey, '1'); } catch(e){}
        bar.style.display = 'none';
      });
    }
  });
})();
